import * as React from 'react';
import cn from 'clsx';

import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';

import * as styles from './styles.css';

interface IDealSalePromoModalLayoutProps extends IWithDeviceTypeProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * Обертка для контента "широких" модалок.
 */
const DealSalePromoModalLayout: React.FC<React.PropsWithChildren<IDealSalePromoModalLayoutProps>> = ({
  className,
  deviceType,
  children,
}) => {
  return <section className={cn(styles['layout'], styles[deviceType], className)}>{children}</section>;
};

const DealSalePromoModalLayoutWithDeviceType = withDeviceType(DealSalePromoModalLayout);
export { DealSalePromoModalLayoutWithDeviceType as DealSalePromoModalLayout };
